// extracted by mini-css-extract-plugin
export default {"clientPublicKey":"CreateEditConfigModal_clientPublicKey__IrP+l","disabled":"CreateEditConfigModal_disabled__SxjU8","serverPublicKey":"CreateEditConfigModal_serverPublicKey__j1CCO"};